<script>

import addApi from "@/view/components/accounts/modal/addApi.vue";
import apiBoxSection from "@/view/components/accounts/partials/apiKeyBox.vue";
import {companyTokens} from "@/api/accounts.js";

export default {
  name: "api-settings",
  components: {
    addApi,
    apiBoxSection
  },
  data() {
    return {
        form: {
            api_key: ""
        },
        options: [],
        loadingFetch : false
    };
  }, 
  async mounted() {
    this.getContent()

    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'modal-add-api'){ // this watch the modal from components/accounts/modal/addApi.vue
        this.getContent()
      }
    })

  },
  computed: {
  },
  watch: {
  },
  methods: {
    async getContent(){
      this.loadingFetch = true
      let resp = await companyTokens()
      this.options = resp
      this.loadingFetch = false
    },
    openApiModal(){
      let componentEvent = this.$refs.addApiMethod
      componentEvent.showModal()
    },
  }
};
</script>

<template>
  <v-card>
    <v-card-title class="pb-1">
      Create your own API keys to connect to your Applications.
    </v-card-title>
    <div class="body-1 ml-4">
      Please read the <a class="font-weight-black" href="https://sales-api.joinaben.com/swagger" target="_blank">API Documentation</a> to learn more about Aben Sales API
    </div>
    <v-card-text>
      <v-btn
        class=""
        md
        depressed
        color="primary"
        @click="openApiModal()"
      >
        Generate API
      </v-btn>
    </v-card-text>
    <div v-if="options.length > 0">
      <v-divider></v-divider>
      <v-card-text>
        <span class="h5">Authentication Keys:</span>
      </v-card-text>
      <api-box-section
        v-for="option in options"
        :key="option.pk"
        :item="option"
        @contentRefresh="getContent"
      ></api-box-section>
    </div>
    <div v-if="options.length <= 0">
      <v-card-text>
      <v-alert
          outlined
          type="info"
          text
          class="outer-container"
      >
        No API availale.
      </v-alert>
      </v-card-text>
    </div>
    <add-api
      ref="addApiMethod"
    >
    </add-api>
    <v-overlay :value="loadingFetch">
      <div class="text-center">
        <p>Fetching content ...</p>
        <v-progress-circular v-if="loadingFetch" indeterminate size="30"></v-progress-circular>
      </div>
    </v-overlay>
  </v-card>
</template>

<style scoped>
.api-item-container{
  padding: 20px 20px 30px;
  width: 300px;
  background-color: #00fffb1a;
  border-radius: 10px;
  text-align: center;
  display: inline-block;
  margin: 0 20px 10px;
}

</style>